module.exports = __webpack_public_path__ + "img/more-options-icon.8567ad35.svg";